module.exports = __webpack_public_path__ + "img/test.920a0280.jpg";